import { Switch } from '@mui/material';
import { styled } from '@mui/styles';

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },

    color: '#004852',
    '& + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));
